module.exports = __webpack_public_path__ + "img/bee.ab975072.jpg";